export const javaAuthExample = `import java.net.URI;
import java.net.http.HttpClient;
import java.net.http.HttpRequest;
import java.net.http.HttpResponse;
import java.nio.charset.StandardCharsets;
import java.time.Instant;
import java.util.HashMap;
import java.util.Map;
import java.util.UUID;
import javax.crypto.Mac;
import javax.crypto.spec.SecretKeySpec;

import com.fasterxml.jackson.databind.ObjectMapper;
import com.fasterxml.jackson.databind.SerializationFeature;

public class ReasonShieldAuthExample {
    private static final String API_KEY = System.getenv("VENDOR_API_KEY");
    private static final String WEBHOOK_SECRET = System.getenv("VENDOR_WEBHOOK_SECRET");
    private static final String VENDOR_ID = System.getenv("VENDOR_ID");
    
    private static final HttpClient httpClient = HttpClient.newHttpClient();
    private static final ObjectMapper objectMapper = new ObjectMapper()
        .configure(SerializationFeature.ORDER_MAP_ENTRIES_BY_KEYS, true);
    
    public static void main(String[] args) {
        try {
            Map<String, Object> testData = new HashMap<>();
            testData.put("test_id", "12345");
            testData.put("panel_type", "RESPIRATORY");
            
            // Call the API with both authentication methods
            Map<String, Object> response = submitData(testData);
            System.out.println("Data submitted successfully: " + response);
            
        } catch (Exception e) {
            System.err.println("Error: " + e.getMessage());
        }
    }
    
    /**
     * Submit data using dual authentication
     */
    public static Map<String, Object> submitData(Map<String, Object> testData) throws Exception {
        String endpoint = "https://app.reasonshield.com/api/v1/lis-webhook/vendor/submit-data";
        
        // Create full payload with required metadata
        Map<String, Object> payload = new HashMap<>();
        payload.put("vendor_id", VENDOR_ID);
        payload.put("timestamp", Instant.now().toString());
        payload.put("request_id", UUID.randomUUID().toString());
        payload.put("test_data", testData);
        
        // Convert payload to JSON with consistent ordering (important for signatures)
        String jsonPayload = objectMapper.writeValueAsString(payload);
        
        // Generate signature
        String signature = generateSignature(jsonPayload, WEBHOOK_SECRET);
        
        // Create HTTP request with both authentication methods
        HttpRequest request = HttpRequest.newBuilder()
            .uri(URI.create(endpoint))
            .header("Content-Type", "application/json")
            .header("Authorization", "Bearer " + API_KEY)      // API Key Authentication
            .header("X-Vendor-Signature", signature)           // Signature Verification
            .POST(HttpRequest.BodyPublishers.ofString(jsonPayload))
            .build();
        
        // Send request
        HttpResponse<String> response = httpClient.send(request, 
            HttpResponse.BodyHandlers.ofString());
        
        // Check response status
        if (response.statusCode() != 200) {
            throw new RuntimeException("API request failed: " + response.body());
        }
        
        // Parse response
        return objectMapper.readValue(response.body(), Map.class);
    }
    
    /**
     * Generate HMAC-SHA256 signature
     */
    private static String generateSignature(String payload, String secret) throws Exception {
        Mac hmac = Mac.getInstance("HmacSHA256");
        SecretKeySpec secretKey = new SecretKeySpec(
            secret.getBytes(StandardCharsets.UTF_8), 
            "HmacSHA256"
        );
        hmac.init(secretKey);
        
        byte[] hash = hmac.doFinal(payload.getBytes(StandardCharsets.UTF_8));
        
        // Convert to hex string
        StringBuilder hexString = new StringBuilder();
        for (byte b : hash) {
            String hex = Integer.toHexString(0xff & b);
            if (hex.length() == 1) {
                hexString.append('0');
            }
            hexString.append(hex);
        }
        
        return hexString.toString();
    }
}`; 